// TODO: deprecated - 請改用 storageKeys.ts 的 COOKIE_KEYS
export const COOKIE_INTERNAL_TRAFFIC = "hs_internal_traffic";
